import * as React from 'react'
function SvgParameterH(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M25.25 22c2.275 0 4.2 1.4 4.9 3.5h2.1c1.05 0 1.75.7 1.75 1.75S33.3 29 32.25 29h-2.1c-.7 1.925-2.625 3.5-4.9 3.5-2.975 0-5.25-2.275-5.25-5.25S22.275 22 25.25 22zm-10.5 3.5c1.05 0 1.75.7 1.75 1.75S15.8 29 14.75 29h-7C6.7 29 6 28.3 6 27.25s.7-1.75 1.75-1.75zm0-17.5C17.725 8 20 10.275 20 13.25s-2.275 5.25-5.25 5.25c-2.275 0-4.2-1.575-4.9-3.5h-2.1C6.7 15 6 14.3 6 13.25s.7-1.75 1.75-1.75h2.1c.7-1.925 2.625-3.5 4.9-3.5zm17.5 3.5c1.05 0 1.75.7 1.75 1.75S33.3 15 32.25 15h-7c-1.05 0-1.75-.7-1.75-1.75s.7-1.75 1.75-1.75z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgParameterH
